<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>{{title}}</h4>
        </div>
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <el-form :inline="true" :model="searchModel" class="demo-form-inline">
                    <el-form-item label="搜索">
                        <el-input v-model="searchModel.keyword" size="small" placeholder="姓名/手机/邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="所属部门" prop="branch_id">
                        <el-cascader
                                :options="branches"
                                v-model="checkedBranch"
                                :props="branchesProps"
                                change-on-select
                                placeholder="请选择所属部门"
                        >
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="职位" prop="role_id">
                        <el-select v-model="searchModel.role_id" placeholder="请选择职位">
                            <el-option
                                    v-for="item in roles"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户状态">
                        <el-select v-model="searchModel.status" size="small" placeholder="请选择状态">
                            <el-option label="激活状态" value="1"></el-option>
                            <el-option label="禁用状态" value="0"></el-option>
                            <el-option label="已删除状态" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <DistrictLinkage ref="DistrictLinkage" :provinceId="searchModel.province_id"
                                         :cityId="searchModel.city_id" 
                                         :districtId="searchModel.district_id"
                                         labelName="绑定地区"
                                         @change="handleChange($event)"></DistrictLinkage>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索
                        </el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row class="addBtn">
                <el-button type="primary" size="small" @click="addUser()">+ 新增用户</el-button>
                <el-button v-if="canUpdateCapacity" type="primary" size="small" :disabled="selectedUsers.length <= 0" @click="openCapacityDialog">编辑库容</el-button>
            </el-row>
            <el-table
                    ref="userTable"
                    :data="users"
                    style="width: 100%"
                    class="tabTopBorder"
                    v-loading="loading"
                    v-watermask
                    @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="45"></el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column label="姓名">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                        <el-popover
                                v-if="scope.row.qr_code"
                                placement="right"
                                title="微信二维码"
                                width="225"
                                trigger="hover"
                               >
                            <img v-if="scope.row.qr_code" width="200" height="200" :src="scope.row.qr_code" class="avatar">
                            <i class="el-icon-fa-qrcode" slot="reference"></i>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="昵称"></el-table-column>
                <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                <el-table-column prop="role_name" label="职位"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
                <el-table-column prop="qq" label="QQ"></el-table-column>
                <el-table-column label="个人库容上限/职位库容上限" width="145">
                    <template slot-scope="scope">
                        <div>绑定：{{scope.row.max_customer_limit || 0}}/{{getUserRoleCapacity(scope.row, 'max_customer_limit')}}</div>
                        <div>A类：{{scope.row.max_vip_limit || 0}}/{{getUserRoleCapacity(scope.row, 'max_vip_limit')}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="state_memo" label="状态"></el-table-column>
                <el-table-column prop="is_common" label="是否公用">
                    <template slot-scope="scope">
                        <i v-if="scope.row.is_common == 1" style="color: #67C23A;" class="el-icon-success"></i>
                        <i v-else style="color: #F56C6C;" class="el-icon-error"></i>
                        <span>{{ scope.row.status_memo }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="entry_at" label="入职时间"></el-table-column>
                <el-table-column prop="created_at" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button v-if="scope.row.is_business" @click="handleArea(scope.row)" type="text" size="small">绑定区域</el-button>
                        <el-button v-else disabled title="只有销售人员才可以绑定区域" type="text" size="small">绑定区域</el-button>
                        <el-button v-if="[11750263].includes($store.getters.userId)" title="只有指定账号才能进行此操作" type="text" size="small" @click="switchAccounts(scope.row)">切换账号</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>

        <div v-if="capacityDialogVisible" class="capacity-panel">
            <div class="capacity-panel-title">
                <span>编辑库容</span>
                <i class="el-icon-close" @click="closeCapacityDialog"></i>
            </div>
            <el-form :model="capacityForm" label-width="160px">
                <el-form-item label="最大绑定客户上限">
                    <el-input-number
                            v-model="capacityForm.max_customer_limit"
                            :min="getSelectedCapacityLimit('max_customer_limit') > 0 ? 1 : 0"
                            :max="getSelectedCapacityLimit('max_customer_limit') > 0 ? getSelectedCapacityLimit('max_customer_limit') : Infinity"
                            :precision="0"
                            :controls="false">
                    </el-input-number>
                    <span v-if="getSelectedCapacityLimit('max_customer_limit') > 0" class="capacity-limit-tip">
                        已选人员中职位最高可设置 {{getSelectedCapacityLimit('max_customer_limit')}}
                    </span>
                </el-form-item>
                <el-form-item label="最大绑定A类客户上限">
                    <el-input-number
                            v-model="capacityForm.max_vip_limit"
                            :min="getSelectedCapacityLimit('max_vip_limit') > 0 ? 1 : 0"
                            :max="getSelectedCapacityLimit('max_vip_limit') > 0 ? getSelectedCapacityLimit('max_vip_limit') : Infinity"
                            :precision="0"
                            :controls="false">
                    </el-input-number>
                    <span v-if="getSelectedCapacityLimit('max_vip_limit') > 0" class="capacity-limit-tip">
                        已选人员中职位最高可设置 {{getSelectedCapacityLimit('max_vip_limit')}}
                    </span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="capacitySaving" @click="saveCapacity">立即保存</el-button>
                    <span class="capacity-selected">已选择 {{selectedUsers.length}} 人</span>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import CommonService from "~/services/common";
    import AccountService from "~/services/account";
    import Pagination from "~/widgets/Pagination.vue";
    import UserService from "~/services/user";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";

    export default {
        components: {
            Pagination,
            CommonService,
            UserService,
            DistrictLinkage,
            AccountService
        },
        data() {
            return {
                title: "用户列表",
                searchModel: {
                    keyword: "",
                    status: "",
                    role_id: "",
                    branch_id: "",
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                },
                branches: [],
                branchesProps: {
                    value: 'id',
                    label: 'name',
                    children: 'childs'
                },
                checkedBranch: [],
                roles: [],
                users: [],
                loading: true,
                capacityDialogVisible: false,
                capacitySaving: false,
                selectedUsers: [],
                capacityForm: {
                    max_customer_limit: 0,
                    max_vip_limit: 0
                },
                // 分页信息
                linkPage: null
            };
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searchModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initListData(params);
        },

        watch: {
            checkedBranch: function (value, original) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.searchModel.branch_id = value[value.length - 1];
                } else {
                    this.searchModel.branch_id = "";
                }
            }
        },

        computed: {
            canUpdateCapacity() {
                return AccountService.can('/users/update-capacity');
            }
        },

        created: function () {
            document.title = this.title;
            this.initListData();
            this.getRoles();
            this.getBranches();
        },

        methods: {

            resetForm() {
                this.searchModel = {
                    keyword: "",
                    status: "",
                    role_id: "",
                    branch_id: "",
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                }
                this.$refs["DistrictLinkage"].reset();
                this.initListData();
            },

            initListData(params = {}) {
                // loading 动画
                this.loading = true;
                UserService.getList(params).then(res => {
                    this.users = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                });
            },

            openCapacityDialog() {
                if (this.selectedUsers.length <= 0) {
                    this.$message.error('请选择要设置库容的用户');
                    return;
                }
                this.capacityDialogVisible = true;
                this.capacityForm = {
                    max_customer_limit: 0,
                    max_vip_limit: 0
                };
                this.applySelectedCapacityLimit();
            },

            handleSelectionChange(selection) {
                this.selectedUsers = selection;
                this.applySelectedCapacityLimit();
            },

            closeCapacityDialog() {
                this.capacityDialogVisible = false;
            },

            saveCapacity() {
                if (this.selectedUsers.length <= 0) {
                    this.$message.error('请选择要设置库容的用户');
                    return;
                }

                this.capacityForm.max_customer_limit = parseInt(this.capacityForm.max_customer_limit) || 0;
                this.capacityForm.max_vip_limit = parseInt(this.capacityForm.max_vip_limit) || 0;

                if (this.capacityForm.max_customer_limit < 0 || this.capacityForm.max_vip_limit < 0) {
                    this.$message.error('库容上限不能小于 0');
                    return;
                }

                if (!this.validateSelectedCapacityLimit()) {
                    return;
                }

                this.capacitySaving = true;
                UserService.updateCapacity({
                    ids: this.selectedUsers.map(user => user.id),
                    max_customer_limit: this.capacityForm.max_customer_limit,
                    max_vip_limit: this.capacityForm.max_vip_limit
                }).then(res => {
                    this.capacitySaving = false;
                    if (res && res.code == 0) {
                        this.$message.success('保存成功');
                        this.closeCapacityDialog();
                        this.initListData(this.searchModel);
                    }
                }).catch(err => {
                    this.capacitySaving = false;
                    console.error(err);
                });
            },

            getRoleById(roleId) {
                return this.roles.find(role => parseInt(role.id) === parseInt(roleId));
            },

            getUserRoleCapacity(user, field) {
                let role = this.getRoleById(user.role_id);
                return role ? (parseInt(role[field]) || 0) : 0;
            },

            getSelectedCapacityLimit(field) {
                let limits = [];
                this.selectedUsers.forEach(user => {
                    let role = this.getRoleById(user.role_id);
                    let limit = role ? (parseInt(role[field]) || 0) : 0;
                    if (limit > 0) {
                        limits.push(limit);
                    }
                });

                if (limits.length <= 0) {
                    return 0;
                }

                return Math.min.apply(null, limits);
            },

            applySelectedCapacityLimit() {
                let customerLimit = this.getSelectedCapacityLimit('max_customer_limit');
                if (customerLimit > 0 && parseInt(this.capacityForm.max_customer_limit) > customerLimit) {
                    this.capacityForm.max_customer_limit = customerLimit;
                }

                let vipLimit = this.getSelectedCapacityLimit('max_vip_limit');
                if (vipLimit > 0 && parseInt(this.capacityForm.max_vip_limit) > vipLimit) {
                    this.capacityForm.max_vip_limit = vipLimit;
                }
            },

            validateSelectedCapacityLimit() {
                let customerLimit = this.getSelectedCapacityLimit('max_customer_limit');
                let customerFormLimit = parseInt(this.capacityForm.max_customer_limit) || 0;
                if (customerLimit > 0 && (customerFormLimit <= 0 || customerFormLimit > customerLimit)) {
                    this.$message.error('个人客户上限不能超过已选人员的职位客户上限(' + customerLimit + ')');
                    return false;
                }

                let vipLimit = this.getSelectedCapacityLimit('max_vip_limit');
                let vipFormLimit = parseInt(this.capacityForm.max_vip_limit) || 0;
                if (vipLimit > 0 && (vipFormLimit <= 0 || vipFormLimit > vipLimit)) {
                    this.$message.error('个人A类客户上限不能超过已选人员的职位A类客户上限(' + vipLimit + ')');
                    return false;
                }

                return true;
            },

            /**
             * 得到角色下拉选项
             */
            getRoles() {
                CommonService.getAllRoles().then(res => {
                    if (res && res.code == 0) {
                        this.roles = res.data.map(role => {
                            role.max_customer_limit = parseInt(role.max_customer_limit) || 0;
                            role.max_vip_limit = parseInt(role.max_vip_limit) || 0;
                            return role;
                        });
                    }
                }).catch(err => {
                    console.error(err);
                })
            },

            /**
             * 得到部门树状结构数据
             */
            getBranches() {
                CommonService.getAllBranches().then(res => {
                    if (res.code == 0 && res.data) {
                        let branches = res.data;
                        delete branches[0];
                        this.branches = res.data;
                    }
                });
            },

            submitSearch() {
                this.initListData(this.searchModel)
            },

            handleView(user) {
                this.$router.push({
                    path: "/users/view",
                    query: {
                        id: user.id
                    }
                });
            },

            handleUpdate(user) {
                this.$router.push({
                    path: "/users/update",
                    query: {
                        id: user.id
                    }
                });
            },

            addUser() {
                this.$router.push({
                    path: "/users/create"
                })
            },

            handleArea(user) {
                this.$router.push({
                    path: "/users/areas",
                    query: {
                        id: user.id
                    }
                });
            },
            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChange(value) {
                this.searchModel.province_id = parseInt(value[0]);
                this.searchModel.city_id = parseInt(value[1]);
                this.searchModel.district_id = parseInt(value[2]);
            },

            switchAccounts(user){
                AccountService.switchAccounts(user.id).then(res => {
                    console.log('切换账号', this.$store.getters, AccountService.getCache());
                    if (res) {
                        this.$notify({
                            title: "登录成功",
                            message: "欢迎进入二一业务系统",
                            type: "success"
                        });
                        this.$router.push({path: "/home"});
                    }
                }).catch(err => {
                    console.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .capacity-panel {
        position: fixed;
        top: 105px;
        left: 50%;
        z-index: 2000;
        width: 760px;
        padding: 20px;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        transform: translateX(-50%);
    }

    .capacity-panel-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 26px;
        color: #303133;
        font-size: 16px;
    }

    .capacity-panel-title .el-icon-close {
        color: #909399;
        cursor: pointer;
    }

    .capacity-panel .el-input-number {
        width: 100%;
    }

    .capacity-limit-tip {
        display: block;
        margin-top: 6px;
        color: #909399;
        line-height: 18px;
    }

    .capacity-selected {
        margin-left: 16px;
        color: #909399;
    }
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue